<template>
  <el-dialog
    title="新增监控店铺"
    :visible.sync="storeAlinkShow"
    :close-on-click-modal="false"
    width="640px"
    id="dialog">
    <el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
      <div class="tagStyle">
        <img src="../../../../assets/img/other/trumpet_icon.png" style="margin-left: 13px;margin-right: 5px;">
        <span>
          淘宝、天猫平台填写旺旺（掌柜）名称，其他平台填写店铺名称。请填写正确的店铺信息，错误信息不
        </span>
        <br>
        <span style="margin-left: 35px;">
          能正常获取数据。
        </span>
      </div>
      <div class="seaerch-wrapper">
        <el-form :label-width="labelWidth" id="shopLink">
          <el-form-item label="平台" :required="true">
            <el-select v-model="storePlatform" size="small" clearable placeholder="请选择" style="width: 440px;">
              <el-option
                v-for="item in platformList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="监控店铺" prop="arrLink" class="require">
            <div class="link_content">
              <div class="link_div_container">
                <div
                  class="link_div"
                  v-for="(item,index) in ruleForm.arrLink"
                  :key="index"
                  v-show="ruleForm.arrLink.length>0"
                >
                  <span
                    v-show="!linkEditShow[index]"
                    :class="ifcheckLink[index]==false?'redlink':''"
                    class="ellipsis"
                  >{{item}}</span>
                  <el-input
                    v-model="link"
                    size="small"
                    v-show="linkEditShow[index]"
                    @blur="blurEditLink(index)"
                  ></el-input>
                  <div style="width: 34px;">
                    <i class="el-icon-edit-outline" @click="editeLink(index)"></i>
                    <i class="el-icon-close" @click="removeLink(index)"></i>
                  </div>
                </div>

              </div>
              <el-input
                clearable
                v-model="ruleForm.link"
                size="small"
                placeholder="一行一个，可多个，最多50个。"
                @blur="blurLink"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <span style="color: #FAAD14;">
              可监控链店铺量上限：{{chiLdNum}}/{{allLimitProNum}}
            </span>
            <el-button size="small" style="float:right;margin-right: 40px;" @click="delRedLink" class="delRedLink">删除爆红店铺</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <span slot="footer">
      <el-button size="small" type="primary" @click="sure">确 定</el-button>
      <el-button size="small" type="TheCustom" @click="storeAlinkShow = false">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getItemId } from "@/libs/index";

export default {
  props: {

  },
  data() {
    return {
      labelWidth: '100px',
      storePlatform: '',
      platformList: [],
      ruleForm: {
        arrLink: [],
        link: "" //用户输入的链接
      },
      linkEditShow: [],
      ifcheckLink: [], //判断是否验证通过
      checkLink: [], //验证的链接
      checkDisabled: false,
      link: "",
      tureLink: [], //正确的链接
      tureLinkObj: [],
      storeAlinkShow: false,
      allLimitProNum: "",
      totalNum: 0,
      chiLdNum: 0,
    };
  },
  methods: {
    faOpen(data) {
      this.allLimitProNum = data.allLimitProNum
      this.platformList = data.shopmonitorPlatform
      this.storeAlinkShow = true
      this.storePlatform = ''
      this.link = ''
      this.ruleForm.link = ''
      this.ruleForm.arrLink = []
      this.totalNum = data.totalNum
      console.log(data.totalNum)
      console.log(this.totalNum)
      this.chiLdNum = 0
      this.chiLdNum = this.totalNum
    },
    editeLink(index) {
      //编辑链接
      this.linkEditShow.forEach((item, i) => {
        if (i == index) {
          this.$set(this.linkEditShow, i, true);
        } else {
          this.$set(this.linkEditShow, i, false);
        }
      });
      this.link = this.ruleForm.arrLink[index];
    },
    delRedLink() {
      //删除爆红链接
      for (var i = this.ifcheckLink.length - 1; i >= 0; i--) {
        if (!this.ifcheckLink[i]) {
          this.ruleForm.arrLink.splice(i, 1);
          this.ifcheckLink.splice(i, 1);
        }
      }
      this.chiLdNum = 0
      this.chiLdNum = this.totalNum + this.ruleForm.arrLink.length
    },

    //判断是否有验证失败的链接
    checkRedLink() {
      this.haveRedLink = [];
      this.haveRedLink = this.ifcheckLink.filter(item => {
        return item == false;
      });
    },
    blurLink() {
      this.linkEditShow = []
      //链接输入框失去焦点，处理数据
      if (this.ruleForm.link) {
        if (this.ruleForm.link.indexOf(' ') != -1) {
          let arr = []
          arr = this.ruleForm.link.split(' ')
          for (let a in arr) {
            this.ruleForm.arrLink.push(arr[a])
          }
        } else {
          this.ruleForm.arrLink.push(this.ruleForm.link);
        }
        if (this.ruleForm.arrLink.length > 0) {
          for (let a in this.ruleForm.arrLink) {
            this.linkEditShow.push(false);
          }
        }
      }
      this.chiLdNum = 0
      this.chiLdNum = this.totalNum + this.ruleForm.arrLink.length
      this.ruleForm.link = ''
      if (this.chiLdNum > this.allLimitProNum) {
        this.$message({
          message: '超出可监控店铺数量上限',
          type: 'warning'
        });
      }
    },
    blurEditLink(index) {
      console.log(this.link)
      this.ruleForm.arrLink[index] = this.link
      this.$set(this.linkEditShow, index, false);
    },
    // 验证是否符合规则
    sure() {
      if (this.chiLdNum > this.allLimitProNum) {
        this.$message({
          message: '超出可监控店铺数量上限',
          type: 'warning'
        });
        return;
      }
      if (!this.storePlatform) {
        this.$message({
          message: '请选择平台',
          type: 'warning'
        });
        return;
      }
      if (this.ruleForm.arrLink.length == 0) {
        this.$message({
          message: '请填写监控店铺',
          type: 'warning'
        });
        return;
      }
      this.chiLdNum = 0
      this.chiLdNum = this.totalNum + this.ruleForm.arrLink.length
      let arr = []
      arr = Array.from(new Set(this.ruleForm.arrLink))
      console.log(arr)
      let params={
        platform: this.storePlatform,
        shopnames: arr.join(','),
      }
      this.ruleForm.arrLink = arr
      fetch({
        url: "hcm/hcmShopMonitor/getRepeatShopname",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          if (data.length > 0) {
            this.ifcheckLink = []
            for (let a in this.ruleForm.arrLink) {
              this.ifcheckLink.push(true)
              for (let b in this.ifcheckLink) {
                if (this.ruleForm.arrLink[a] === data[b]) {
                  this.ifcheckLink[a] = false
                }
              }
            }
          } else {
            this.storeAlinkShow = false
            let faData = []
            for (let a in this.ruleForm.arrLink) {
              faData.push({
                platformchild: this.storePlatform,
                shopnamechild: this.ruleForm.arrLink[a]
              })
            }
            console.log(faData)
            this.$emit('fromChild', faData)
          }
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },

    removeLink(index) {
      //删除链接
      this.ruleForm.arrLink.splice(index, 1);
      this.ifcheckLink.splice(index, 1);
      this.chiLdNum = 0
      this.chiLdNum = this.totalNum + this.ruleForm.arrLink.length
      this.$emit("delFalseLink", index);
    },
  }
};
</script>
<style lang="scss">
.tagStyle {
  background-color: #fdf6ec;
  border-color: #faecd8;
  color: #e6a23c;
  display: inline-block;
  padding: 0 10px;
  line-height: 30px;
  font-size: 12px;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
  width: 100%;
}
#shopLink {
  .ellipsis {
    width: 90%;
  }
  .link_content {
    padding: 10px;
    border: 1px solid #dcdfe6;
    height: 252px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 440px;
    .link_div_container {
      max-height: 200px;
      overflow-y: auto;
    }
    .el-input__inner {
      border: none;
    }
  }
  .require .el-form-item__label {
    &::before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }
  .link_div {
    height: 24px;
    line-height: 24px;
    border: 1px solid #dcdfe6;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    padding-right: 5px;
    box-sizing: border-box;
    margin-bottom: 5px;
    border-radius: 4px;
    .el-input--small .el-input__inner {
      height: 18px;
      line-height: 18px;
      border: none;
    }
  }
  .el-icon-edit-outline {
    font-size: 14px;
    color: #108cee;
  }
  .redlink {
    color: red;
  }
  #dialog {
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
}
</style>
